// blog data

export const Blogs = [
    {
        id: 1,
        name: "CSS {type : kick-off;}",
        "tags": "#stylesheet, #Css, #beautify",
        "date": "2021-05-16",
        "discription": "A Cascading Style Sheet, commonly known as CSS, is the layer of styling over HTML elements, or in simpler terms, it lets you style the elements (font, size, color, and spacing) of your HTML pages and content by gently applying classes to it.",
        "photoLink": "https://res.cloudinary.com/practicaldev/image/fetch/s--hW-ylKqb--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/pl0pxer6eut9fhaf3cmt.png",
        "blogLink": "https://dev.to/moglten/css-type-kick-off-53c0",
    
    },
    {
        "id": 2,
        "name": "Generative Adversarial Networks",
        "tags": "#Deep Learning, #GAN, #Randomness",
        "date": "2022-03-25",
        "discription": "we have something here",
        "photoLink": "https://media-zep-analytics.s3.ap-south-1.amazonaws.com/uploads/blogs/1647984895.jpeg",
        "blogLink": "https://zepanalytics.com/blogs/generative-adversarial-networks",
    },
    {
        "id": 3,
        "name": "My Algorithm is Optimal!",
        "tags": "#Algorithm, #Datastructure, #optimal",
        "date": "2022-07-25",
        "discription": "we have something here",
        "photoLink": "https://res.cloudinary.com/practicaldev/image/fetch/s--oIhxhtBQ--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/t1vwrlmchh7o5ea5api4.png",
        "blogLink": "https://dev.to/moglten/my-algorithm-is-optimal-5bbp",
    }
]

export default Blogs